<template>
    <UpdateJob></UpdateJob>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UpdateJob = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/UpdateJob.vue"
    )
);

export default {
    name: "Project_HelpUpdateJob", //The name you are in should not equal the name of the component you are importing.
    components: { UpdateJob, AuthLayout },
};
</script>
